export default __webpack_public_path__ + "static/media/property_362.5216e349.png";